import React, { Component } from 'react';
import createReactClass from 'create-react-class';
import { NavLink, withRouter } from 'react-router-dom';
import hb from 'images/shb-large-logo.svg';

import UserSessionPanel from 'components/UserSessionPanel';

//  let logo; /* eslint-disable-line no-unused-vars */
if (process.env.NODE_ENV !== 'test') {
  require('./Header.scss');
}

const HeaderMenu = withRouter(
  createReactClass({
    displayName: 'HeaderMenu',

    getInitialState() {
      return {
        open: false,
      };
    },

    toggleNav() {
      this.setState({ open: !this.state.open });
    },

    closeNav() {
      this.setState({ open: false });
    },

    render() {
      const {
        location: { pathname },
      } = this.props;

      return (
        <div className="navigation-wrapper">
          <nav role="navigation">
            <button
              type="button"
              className="btn btn-hamburger"
              onClick={() => this.toggleNav()}
            >
              <span />
              <span />
              <span />
            </button>
            <ul
              onClick={() => this.closeNav()}
              className={
                this.state.open ? 'navigation-menu open' : 'navigation-menu'
              }
            >
              <li>
                <NavLink to="/admin/users">Brukere</NavLink>
              </li>
              <li>
                <NavLink to="/admin/customers">Kunder</NavLink>
              </li>
              <li>
                <NavLink to="/admin/editor">Editor</NavLink>
              </li>
              <li>
                <NavLink to="/admin/reports">Rapporter</NavLink>
              </li>
              <li>
                <NavLink to="/admin/audit">Audit</NavLink>
              </li>
              <li>
                <a
                  href="http://kunde.manamind.com/wp-login.php?redirect_to=http://kunde.manamind.com/hb/&reauth=1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Kundeweb
                </a>
              </li>
            </ul>
            <ul onClick={() => this.closeNav()} className="navigation-submenu">
              {pathname.startsWith('/admin/users') && (
                <>
                  <li>
                    <NavLink exact to="/admin/users">
                      Liste
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/admin/users/new">Ny bruker</NavLink>
                  </li>
                </>
              )}
              {pathname.startsWith('/admin/customers') && (
                <li>
                  <NavLink exact to="/admin/customers">
                    Liste
                  </NavLink>
                </li>
              )}
              {pathname.startsWith('/admin/editor') && (
                <li>
                  <NavLink to="/admin/editor/sniplets">Sniplets</NavLink>
                  <NavLink to="/admin/editor/currency">Valuta</NavLink>
                </li>
              )}
              {pathname.startsWith('/admin/reports') && (
                <>
                  <li>
                    <NavLink exact to="/admin/reports">
                      Rapporter
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/admin/reports/new/company">
                      Ny Selskapsrapport
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/admin/reports/new/morning">
                      Ny Strategirapport
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/admin/reports/new/strategy">
                      Ny Makrorapport
                    </NavLink>
                  </li>
                </>
              )}
              {pathname.startsWith('/admin/audit') && (
                <>
                  <li>
                    <NavLink exact to="/admin/audit/report">
                      Rapport
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/admin/audit/search">Søk</NavLink>
                  </li>
                  <li>
                    <NavLink to="/admin/audit/statistics">Statistikk</NavLink>
                  </li>
                </>
              )}
            </ul>
          </nav>
        </div>
      );
    },
  }),
);

export default class Header extends Component {
  static displayName = 'Header';

  render() {
    return (
      <header className="admin">
        {/* Mobile logo */}
        <div className="logo-container visible-xs">
          <img className="logo" src={hb} alt="Handelsbanken logo" />

          <div className="prime">
            <p>Admin Prime</p>
          </div>
        </div>

        {/* Desktop logo */}
        <div className="logo-container hidden-xs">
          <img className="logo" src={hb} alt="Handelsbanken logo" />
          <div className="prime">
            <p>Admin Prime</p>
          </div>

          <div className="user-panel">
            <UserSessionPanel adminMode />
          </div>
        </div>

        <HeaderMenu />
      </header>
    );
  }
}
